import { ApiAttributionModel, ApiChartAttribute } from "@incendium/api";
import { Drawer, DrawerProps, Stack } from "@mui/material";
import { DatePickerDropdown } from "features/analytics";
import AnalyticsAttributionSwitcher from "features/analytics/components/AnalyticsAttributionSwitcher";
import { ChartBuilderAttributes } from "features/chartLibrary";
import { CallbackOrVal } from "Interfaces";
import { useCallback } from "react";

interface IDashboardSettingsProps extends DrawerProps {
  model: ApiAttributionModel | null;
  setModel: (model: ApiAttributionModel) => void;
  selectedAttributes: ApiChartAttribute[];
  setSelectedAttributes: (val: CallbackOrVal<ApiChartAttribute[]>) => void;
}

function DashboardSettings({
  model,
  setModel,
  selectedAttributes,
  setSelectedAttributes,
  open,
  onClose,
}: IDashboardSettingsProps) {
  const onChange = useCallback(
    (v: CallbackOrVal<ApiAttributionModel[]>) => {
      setModel(v[0] || ApiAttributionModel.EBA);
    },
    [setModel],
  );
  return (
    <Drawer
      anchor={"bottom"}
      onClose={onClose}
      open={open}
      sx={{ width: "100%", bottom: 54 }}
      PaperProps={{
        sx: {
          width: "100%",
          minWidth: "100%",
          maxWidth: "100%",
          padding: 2,
          paddingTop: 4,
          paddingBottom: 10,
          //  hack for filters
          "& .MuiGrid-root": {
            width: "100%",
          },
        },
      }}
    >
      <Stack spacing={2}>
        <DatePickerDropdown
          size="small"
          label="select date range"
          hideAdvanced
        />
        <AnalyticsAttributionSwitcher
          models={[model]}
          setModels={onChange}
          withBg
          fullWidth
        />
        <ChartBuilderAttributes
          title="Filters"
          subTitle="Select the filters you want to apply to this report"
          attributes={selectedAttributes}
          setAttributes={setSelectedAttributes}
        />
      </Stack>
    </Drawer>
  );
}

export default DashboardSettings;
